import api from "../axios";

export const GetAllCategory = (data) => api.get("category/all", data);
export const CategoryCount = (data) =>
  api.get(`category/eventcounts${data}`, data);
